import { resolveEstimateStatus } from "./estimates";

/** Builder entry modes from the Estimate Summary actions. */
export const ESTIMATE_BUILDER_MODES = {
  EDIT: "edit",
  UPDATE: "update",
  REVIEW: "review",
};

/**
 * Summary-screen action visibility per lifecycle status.
 * @param {string} status
 * @param {{ linkedProjectId?: string | null }} options
 */
export function getEstimateSummaryActions(status, { linkedProjectId } = {}) {
  const resolved = resolveEstimateStatus(status);

  const actions = {
    editEstimate: false,
    previewReport: false,
    reviewEstimate: false,
    generateReport: false,
    updateEstimate: false,
    createProject: false,
    openProject: false,
  };

  switch (resolved) {
    case "draft":
      actions.editEstimate = true;
      actions.previewReport = true;
      break;
    case "ready":
      actions.reviewEstimate = true;
      actions.generateReport = true;
      break;
    case "sent":
      actions.reviewEstimate = true;
      actions.generateReport = true;
      actions.updateEstimate = true;
      break;
    case "approved":
      actions.reviewEstimate = true;
      actions.generateReport = true;
      if (linkedProjectId) {
        actions.openProject = true;
      } else {
        actions.createProject = true;
      }
      break;
    case "declined":
      actions.reviewEstimate = true;
      actions.generateReport = true;
      break;
    case "converted":
      actions.reviewEstimate = true;
      if (linkedProjectId) {
        actions.openProject = true;
      }
      break;
    case "archived":
      actions.reviewEstimate = true;
      break;
    default:
      break;
  }

  return actions;
}

/**
 * Whether the estimate builder allows structural/content edits.
 * Review mode is always read-only. Edit mode requires draft. Update mode requires sent.
 */
export function isEstimateBuilderEditable(status, builderMode) {
  if (builderMode === ESTIMATE_BUILDER_MODES.REVIEW) {
    return false;
  }

  const resolved = resolveEstimateStatus(status);

  if (builderMode === ESTIMATE_BUILDER_MODES.EDIT) {
    return resolved === "draft";
  }

  if (builderMode === ESTIMATE_BUILDER_MODES.UPDATE) {
    return resolved === "sent";
  }

  return false;
}

export function getBuilderShellTitle(builderMode, isNewEstimate) {
  if (isNewEstimate) return "New Estimate";
  if (builderMode === ESTIMATE_BUILDER_MODES.REVIEW) return "Review Estimate";
  if (builderMode === ESTIMATE_BUILDER_MODES.UPDATE) return "Update Estimate";
  return "Edit Estimate";
}
